module.exports = __webpack_public_path__ + "img/BG813155318.ec69bed8.png";